import LoginPage from "views/Auth/Login/LoginPage";

import { Route, Routes } from "react-router-dom";
import { useState } from "react";
import { AuthRoute } from "routing";
import RegistrationPage from "views/Auth/Registration/RegistrationPage";
import MainPage from "../views/Manager/MainPage";

const ManagerRoutes = () => {
    
  //const [activeToolbar, setActiveToolbar] = useState(null);

  return (
    <Routes>
      
      <Route path='/login' element={<LoginPage />}/>
      <Route path='/registration' element={<RegistrationPage />}/>
      
      <Route element={<AuthRoute />}>

      <Route path='/*' element={<MainPage />} /> 
            
              
      </Route>
    </Routes>
  ) ; 
  

};

export default ManagerRoutes;